
<template>
    <div>
        <b-form @submit="sendForm">
            <div class="setup-form p-5">
                <h1 class="complete-account-setup-heading">Create your loyalty program</h1>
                <p class="complete-account-setup-description">Lorem ipsum dolor sit amet, co nsectetur adipiscing elit. Lorem ipsum dolor sit amet, consect etur.</p>
                <b-row>
                    <b-col cols="10">
                            <b-row class="mt-5">
                                <b-col sm="12" md="2"
                                    :class="{'col-md-3 text-left': isSetup}"><h6 class="align-middle">Points</h6>
                                </b-col>
                                <b-col sm="12" md="7"
                                    :class="{'col-md-9': isSetup}">
                                    <div class="mb-5"
                                        :class="{'text-left': isSetup}">
                                        <div style="margin-top: 1px;">
                                            <span class="label-helper align-top">Earning</span>
                                            <i class="guide-tooltip" id="earning-guide"></i>
                                            <b-popover target="earning-guide" triggers="hover" content="Nominate the minimum transaction value and equivalent points that customers can earn."></b-popover>
                                        </div>
                                        <div class="form-container">
                                            <b-row no-gutters>
                                                <b-col cols="7">
                                                    <b-row><b-col><span class="d-block mb-2 up-label">Currency</span></b-col></b-row>
                                                    <b-row no-gutters>
                                                        <b-col cols="1"><i class="icon d-block" style="margin-top: 9px;"><img src="@/assets/images/mechanics/currency.svg" alt="Currency Icon"></i></b-col>
                                                        <b-col class="p-1"><b-form-select v-model="stepTwoForm.points.currency" :options="currencyOptions"/></b-col>
                                                        <b-col class="p-1">
                                                            <b-form-group :state="isValid('amount')">
                                                                <b-form-input type="number" :formatter="pointsFormatter" placeholder="0" min="1" value="0" step="1" v-model="stepTwoForm.points.amount"></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                                <b-col cols="1">
                                                    <i class="icon mx-auto d-block" style="margin-top: 4px;"><img src="@/assets/images/mechanics/convert.svg" alt="Convert Icon" style="margin-top: 36px;"></i>
                                                </b-col>
                                                <b-col>
                                                    <b-row><b-col><span class="d-block mb-2 up-label">Points</span></b-col></b-row>
                                                    <b-row no-gutters>
                                                        <b-col cols="2"><i class="icon d-block" style="margin-top: 9px;"><img src="@/assets/images/mechanics/points.svg" alt="Points Icon"></i></b-col>
                                                        <b-col class="py-1">
                                                            <b-form-group :state="isValid('points')">
                                                            <b-form-input type="number" :formatter="pointsFormatter" value="1" disabled="disabled"></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </div>
                                    <div class="mb-5"
                                        :class="{'text-left': isSetup}">
                                        <div style="margin-top: 1px;">
                                            <span class="label-helper align-top">Pay with Points</span>
                                            <i class="guide-tooltip" id="redemption-guide"></i>
                                            <b-popover target="redemption-guide" triggers="hover" content="Nominate the minimum points required and the equivalent monetary value that customers can use as payment."></b-popover>
                                        </div>
                                        <div class="form-container">
                                            <b-row no-gutters>
                                                <b-col>
                                                    <b-row><b-col><span class="d-block mb-2 up-label">Points</span></b-col></b-row>
                                                    <b-row no-gutters>
                                                        <b-col cols="2"><i class="icon d-block" style="margin-top: 9px;"><img src="@/assets/images/mechanics/points.svg" alt="Points Icon"></i></b-col>
                                                        <b-col class="py-1">
                                                            <b-form-group :state="isValid('redeem_amount')">
                                                                <b-form-input type="number" :formatter="pointsFormatter" value="1" disabled="disabled"></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                                <b-col cols="1"><i class="icon mx-auto d-block" style="margin-top: 4px;"><img src="@/assets/images/mechanics/convert.svg" alt="Convert Icon" style="margin-top: 36px;"></i></b-col>
                                                <b-col cols="7">
                                                    <b-row><b-col><span class="d-block mb-2 up-label">Currency</span></b-col></b-row>
                                                    <b-row no-gutters>
                                                        <b-col cols="1"><i class="icon d-block" style="margin-top: 9px;"><img src="@/assets/images/mechanics/currency.svg" alt="Currency Icon"></i></b-col>
                                                        <b-col class="p-1"><b-form-select v-model="stepTwoForm.points.redeem_currency" :options="currencyOptions"/></b-col>
                                                        <b-col class="p-1">
                                                            <b-form-group :state="isValid('redeem_amount')">
                                                                <b-form-input type="number" :formatter="pointsFormatter" placeholder="0" min="1" step="1" v-model="stepTwoForm.points.redeem_amount"></b-form-input>
                                                            </b-form-group>
                                                        </b-col>
                                                    </b-row>
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </div>
                                    <div class="mb-3"
                                        :class="{'text-left': isSetup}">
                                        <b-row>
                                            <b-col cols="4">
                                                <span class="sl-helper d-block mb-1">Points Expiry</span>
                                                <switches
                                                    v-model="stepTwoForm.points.expiration"
                                                    theme="custom"
                                                    color="primary"
                                                    type-bold="true"
                                                    style="top: -8px;"
                                                    text-enabled="On"
                                                    text-disabled="Off">
                                                </switches>
                                            </b-col>
                                            <b-col cols="4">
                                                <span class="sl-helper d-block mb-1">Validity</span>
                                                <b-form-select
                                                    v-model="stepTwoForm.points.validity"
                                                    :options="validityOptions"
                                                    text-enabled="On"
                                                    text-disabled="Off"
                                                />
                                            </b-col>
                                        </b-row>
                                    </div>
                                </b-col>
                            </b-row>
                            <hr>
                            <b-row class="mt-5">
                                <b-col sm="12" md="2"
                                    :class="{'col-md-3 text-left': isSetup}"><h6 class="align-middle">Branches</h6>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                        id="brand-fieldset"
                                        label-for="brand"
                                        :invalid-feedback="errorMessage('name')"
                                        :state="isValid('name')"
                                    >
                                        <template slot="label">
                                            Brand
                                            <i class="ic-tooltip ml-1 d-inline-block" id="brand-tooltip"></i>
                                            <b-popover target="brand-tooltip" triggers="hover" content="Tell us your company’s brand name"></b-popover>
                                        </template>
                                        <b-form-input 
                                            id="brand" 
                                            placeholder="Brand" 
                                            v-model="stepTwoForm.brand.name"
                                            required>
                                        </b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        id="branch-name-fieldset"
                                        label="Branch Name"
                                        label-for="branch-name"
                                        :invalid-feedback="branchErrorMessage('name')"
                                        :state="branchIsValid('name')"
                                    >
                                        <b-form-input
                                            id="branch-name"
                                            placeholder="Branch Name"
                                            v-model="stepTwoForm.branch.name"
                                            required>
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <hr class="my-4">
                            <b-row class="mt-5">
                                <b-col sm="12" md="2"
                                    :class="{'col-md-3 text-left': isSetup}"><h6 class="align-middle">Employee</h6>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                        id="employee-id-fieldset"
                                        label-for="employee-id"
                                    >
                                        <template slot="label">
                                            Employee ID
                                            <i class="ic-tooltip ml-1 d-inline-block" id="employee-id-tooltip"></i>
                                            <b-popover target="employee-id-tooltip" triggers="hover" content="Tell us your employee identification number."></b-popover>
                                        </template>
                                        <b-form-input id="employee-id" placeholder="Employee ID" value="0001" disabled></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        id="full-name-fieldset"
                                        label="Full Name"
                                        label-for="full-name"
                                        :invalid-feedback="branchErrorMessage('fullname')"
                                        :state="branchIsValid('fullname')"
                                    >
                                        <b-form-input
                                            id="full-name"
                                            placeholder="Full Name"
                                            v-model="stepTwoForm.employee.fullname"
                                            required
                                        ></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        id="email-fieldset"
                                        label="Email"
                                        label-for="email"
                                        :invalid-feedback="branchErrorMessage('email')"
                                        :state="branchIsValid('email')"
                                    >
                                        <b-form-input 
                                            id="email" 
                                            placeholder="Email" 
                                            type="email" 
                                            v-model="stepTwoForm.employee.email"
                                            required
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        
                    </b-col>
                    <b-col></b-col>
                </b-row>
            </div>
            <div class="button-wrapper px-5 py-3" v-bind:class="{ 'retain-height': subIsActive('/setup/start') }">
                <b-button variant="outline-secondary" v-show="!subIsActive('/setup/start')" :to="'/setup/start'">
                    Back
                </b-button>
                <!-- <b-button variant="primary" class="float-right" :to="'/setup/step-3'"> -->
                <b-button variant="primary" class="float-right" type="submit">
                    <span v-if="loading">Submitting...</span>
                    <span v-else>Next</span>
                </b-button>
            </div>
        </b-form>
    </div>
</template>

<script>
import Switches from "vue-switches";
const defaultLogo = require('@/assets/images/default-logo.jpg');
import image2base64 from "image-to-base64";
import { mapState } from "vuex";

export default {
    name: 'step-2',
    data() {
        return {
            isSetup: true,
            currencyOptions: ["PHP", "USD"],
            validityOptions: [
                { value: "+3 months", text: "3 Months" },
                { value: "+6 months", text: "6 Months" },
                { value: "+1 year", text: "1 Year" },
                { value: "+2 years", text: "2 Years" },
                { value: "+3 years", text: "3 Years" },
                { value: "+4 years", text: "4 Years" },
                { value: "+5 years", text: "5 Years" },
                { value: "+10 years", text: "10 Years" },
                { value: "+15 years", text: "15 Years" }
            ],
            submittedbtn: false,
            // loading: false,
            currentPosition: {
                lat: 14.599512,
                long: 120.984222
            }
        }
    },
    components: {
        Switches
    },
    computed: {
        ...mapState('setup', 
            [
                'stepTwoForm',
                'nextStep',
                'errors',
                'loading',
                'branchErrors'
            ])
    },
    created() {
        this.$store.dispatch("setup/getStepTwoDetails");
    },
    methods: {
        subIsActive(input) {
            const paths = Array.isArray(input) ? input : [input];
            return paths.some(path => {
                return this.$route.path.indexOf(path) === 0; // current path starts with this path string
            });
        },
        async sendForm(evt) {
            evt.preventDefault();
            this.$store.dispatch("setup/resetErrors");
            image2base64(defaultLogo) // you can also to use url
            .then(
                (response) => {
                    // console.log(response); //cGF0aC90by9maWxlLmpwZw==
                    this.stepTwoForm.brand.brand_image = response;
                    this.stepTwoForm.branch.branch_image = response;
                    this.stepTwoForm.branch.longitude = this.currentPosition.long;
                    this.stepTwoForm.branch.latitude = this.currentPosition.lat;
                    // console.log(this.stepTwoForm);
                    this.$store.dispatch("setup/saveStepTwo", this.stepTwoForm);
                }
            )
            .catch(
                (error) => {
                    console.log(error); //Exepection error....
                }
            )
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }
            return this.errors.errors[field];
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }
            return this.errors.errors[field] ? false : true;
        },
        branchErrorMessage(field) {
            if (this.branchErrors == null) {
                return "";
            }
            return this.branchErrors[field];
        },
        branchIsValid(field) {
            if (this.branchErrors == null) {
                return false;
            }
            return this.branchErrors[field] ? false : true;
        },
        pointsFormatter(value, event) {
            return event === null ? value : value * 1;
        }
    }
};
</script>
<style lang="scss">
</style>